<template>
<!--  积分相关的,只有中文版才有,-->
    <copy-shell
        :dialog-show="dialogShow"
        :title-drawer="$t('Redemption_Details')"
        @close="closeHandle"
    >
        <div class="drawer-content-inner exchangeDetail"
        >
          <div class="item-line">
            <div class="label">{{$t('Redeem_products')}}</div>
            <div class="dotte-line"></div>
            <div class="data-box">{{detailData.productName}}</div>
          </div>
          <div class="item-line">
            <div class="label">{{$t('quantity')}}</div>
            <div class="dotte-line"></div>
            <div class="data-box">{{detailData.quantity}}</div>
          </div>
          <div
            v-if="!isMaterial"
            class="item-line">
            <div class="label">{{$t('Bonus_Account')}}</div>
            <div class="dotte-line"></div>
            <div class="data-box">{{detailData.remark || '-'}}</div>
          </div>
          <div
            v-if="isMaterial"
            class="item-line">
            <div class="label">{{$t('remark')}}</div>
            <div class="dotte-line"></div>
            <div class="data-box">{{detailData.remark || '-'}}</div>
          </div>
          <div class="item-line">
            <div class="label">{{$t('User.applyTime')}}</div>
            <div class="dotte-line"></div>
            <div class="data-box">{{parseTime(detailData.createTime)}}</div>
          </div>
          <div class="item-line">
            <div class="label">状态</div>
            <div class="dotte-line"></div>
            <div class="data-box">{{computedStatus}}</div>
          </div>
          <div
            v-if="isMaterial"
            class="item-line">
            <div class="label">{{$t('Consignees_name')}}</div>
            <div class="dotte-line"></div>
            <div class="data-box">{{detailData.addressSnapshot.name}}</div>
          </div>
          <div
            v-if="isMaterial"
            class="item-line">
            <div class="label">{{$t('Contact_Number')}}</div>
            <div class="dotte-line"></div>
            <div class="data-box">{{detailData.addressSnapshot.phone}}</div>
          </div>
          <div
            v-if="isMaterial"
            class="item-line last">
            <div class="label">{{$t('Delivery_address')}}</div>
            <div class="dotte-line"></div>
            <div class="data-box">{{detailData.addressSnapshot.address}}</div>
          </div>
        </div>
    </copy-shell>
</template>

<script>
    import { parseTime } from '@/utils/index'
    import { mapGetters } from 'vuex'
    import copyShell from '@/components/common/copyShell';
  export default {
    name: 'exchangeDetail',
    props: {
      dialogShow: {
        type: Boolean,
        default: false,
      },
      detailData:{
        type: Object,
        default(){
          return {
            productName: '',
            num: 1,
            remark: '',
            time: '',
            status: 1,
            receiveName: '',
            receivePhone: '',
            receiveAddress: '',
          }
        }
      }
    },
    components:{
      copyShell,
    },
    data() {
      return {

      };
    },
    watch:{

    },
    computed: {
      ...mapGetters(['userInfo']),
      computedStatus(){
        if(this.detailData.status == 1){
          return this.$t('withgold.withgoldOut1');
        }else if(this.detailData.status == 3){
          return this.$t('User.authPass');
        }else if(this.detailData.status == 2){
          return this.$t('User.authPass');
        }
      },
      isMaterial(){
        return this.detailData.productType == 1;
      }
    },
    methods: {
      parseTime,
      closeHandle() {
        this.$emit('close');
      },
    }
  };
</script>

<style lang="scss" scoped>
    @import "../../assets/scss/variable";
.exchangeDetail {
  .item-line {
    display: flex;
    justify-content: space-around;
    align-items: center;
    font-size: 14px;
    margin-bottom: 20px;
    color: #333333;
    .dotte-line {
      height: 0;
      border-bottom: 1px dotted #999999;
      flex: 1;
      margin: 0 10px;
    }
    &.last {
      .label {
        min-width: 60px;
      }
      .dotte-line {
        min-width: 100px;
      }
    }
  }
}






















































</style>
